export const sharedTranslations = {
  fr: {
    anonymousUser: "Utilisateur",
    copy: "copie",
    copying: "Copie en cours...",
    copyError: "Erreur lors de la copie",
    notFound: "Contenu introuvable",
    backHome: "Retour à l'accueil",
    sharedBy: "Partagé par {{name}}",
    createFreeAccount: "Créer un compte gratuit",
    // Sheet
    sheetCopied: "Fiche copiée dans votre bibliothèque !",
    sheetNotFoundDesc: "Cette fiche n'existe pas ou n'est plus publique.",
    copySheet: "Copier dans mes fiches",
    sheetSEO: "Fiche de révision Sclépios IA",
    sheetDefaultDesc: "Fiche de révision médicale sur Sclépios IA",
    // Quiz
    quizTitle: "Score de {{percentage}}%",
    quizDesc: "{{score}}/{{total}} bonnes réponses",
    quizNotFoundDesc: "Ce quiz n'existe pas ou n'est plus public.",
    quizSEO: "Quiz Sclépios IA",
    quizDefaultDesc: "Quiz médical : {{score}}/{{total}} sur Sclépios IA",
    replayQuiz: "Lancer un quiz",
    previewQuestions: "Aperçu des questions",
    questionN: "Question {{n}}",
    moreQuestions: "+{{count}} autres questions",
    quizShareText: "🧠 J'ai obtenu {{percentage}}% ({{score}}/{{total}}) sur ce quiz Sclépios IA !",
    // Case
    caseNotFoundDesc: "Ce cas clinique n'existe pas ou n'est plus public.",
    caseSEO: "Cas clinique Sclépios IA",
    caseDefaultDesc: "Cas clinique : {{title}} ({{specialty}}) sur Sclépios IA",
    caseScore: "{{percentage}}% — {{score}}/{{total}} bonnes réponses",
    tryCase: "Tenter un cas clinique",
    caseShareText: "🏥 Cas clinique \"{{title}}\" — {{percentage}}% sur Sclépios IA !",
    // Toggle
    makePublic: "Rendre public",
    makePrivate: "Rendre privé",
    madePublicCopied: "✅ Public ! Lien copié dans le presse-papier",
    madePrivate: "🔒 Fiche repassée en privé",
    toggleError: "Erreur lors du changement de visibilité",
  },
  en: {
    anonymousUser: "User",
    copy: "copy",
    copying: "Copying...",
    copyError: "Error copying",
    notFound: "Content not found",
    backHome: "Back to home",
    sharedBy: "Shared by {{name}}",
    createFreeAccount: "Create free account",
    sheetCopied: "Sheet copied to your library!",
    sheetNotFoundDesc: "This sheet doesn't exist or is no longer public.",
    copySheet: "Copy to my sheets",
    sheetSEO: "Revision Sheet — Sclépios AI",
    sheetDefaultDesc: "Medical revision sheet on Sclépios AI",
    quizTitle: "Score: {{percentage}}%",
    quizDesc: "{{score}}/{{total}} correct answers",
    quizNotFoundDesc: "This quiz doesn't exist or is no longer public.",
    quizSEO: "Quiz — Sclépios AI",
    quizDefaultDesc: "Medical quiz: {{score}}/{{total}} on Sclépios AI",
    replayQuiz: "Start a quiz",
    previewQuestions: "Preview questions",
    questionN: "Question {{n}}",
    moreQuestions: "+{{count}} more questions",
    quizShareText: "🧠 I scored {{percentage}}% ({{score}}/{{total}}) on this Sclépios AI quiz!",
    caseNotFoundDesc: "This clinical case doesn't exist or is no longer public.",
    caseSEO: "Clinical Case — Sclépios AI",
    caseDefaultDesc: "Clinical case: {{title}} ({{specialty}}) on Sclépios AI",
    caseScore: "{{percentage}}% — {{score}}/{{total}} correct answers",
    tryCase: "Try a clinical case",
    caseShareText: "🏥 Clinical case \"{{title}}\" — {{percentage}}% on Sclépios AI!",
    makePublic: "Make public",
    makePrivate: "Make private",
    madePublicCopied: "✅ Public! Link copied to clipboard",
    madePrivate: "🔒 Made private",
    toggleError: "Error changing visibility",
  },
  es: {
    anonymousUser: "Usuario",
    copy: "copia",
    copying: "Copiando...",
    copyError: "Error al copiar",
    notFound: "Contenido no encontrado",
    backHome: "Volver al inicio",
    sharedBy: "Compartido por {{name}}",
    createFreeAccount: "Crear cuenta gratis",
    sheetCopied: "¡Ficha copiada a tu biblioteca!",
    sheetNotFoundDesc: "Esta ficha no existe o ya no es pública.",
    copySheet: "Copiar a mis fichas",
    sheetSEO: "Ficha de repaso — Sclépios IA",
    sheetDefaultDesc: "Ficha de repaso médica en Sclépios IA",
    quizTitle: "Puntuación: {{percentage}}%",
    quizDesc: "{{score}}/{{total}} respuestas correctas",
    quizNotFoundDesc: "Este quiz no existe o ya no es público.",
    quizSEO: "Quiz — Sclépios IA",
    quizDefaultDesc: "Quiz médico: {{score}}/{{total}} en Sclépios IA",
    replayQuiz: "Iniciar un quiz",
    previewQuestions: "Vista previa",
    questionN: "Pregunta {{n}}",
    moreQuestions: "+{{count}} preguntas más",
    quizShareText: "🧠 ¡Obtuve {{percentage}}% ({{score}}/{{total}}) en este quiz de Sclépios IA!",
    caseNotFoundDesc: "Este caso clínico no existe o ya no es público.",
    caseSEO: "Caso clínico — Sclépios IA",
    caseDefaultDesc: "Caso clínico: {{title}} ({{specialty}}) en Sclépios IA",
    caseScore: "{{percentage}}% — {{score}}/{{total}} respuestas correctas",
    tryCase: "Intentar un caso clínico",
    caseShareText: "🏥 Caso clínico \"{{title}}\" — {{percentage}}% en Sclépios IA!",
    makePublic: "Hacer público",
    makePrivate: "Hacer privado",
    madePublicCopied: "✅ ¡Público! Enlace copiado",
    madePrivate: "🔒 Hecho privado",
    toggleError: "Error al cambiar visibilidad",
  },
};
